/* eslint-disable */
import React from "react";
import Snackbar from "@material-ui/core/Snackbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import {IDataSource} from '../types';
import { useBulkExportAPI } from "../hooks/useBulkExportAPI";
import { useHookSubscribe } from "../../../react-rxjs";

type OwnProps = {
  messageComponent: React.FC<{measurement?: IDataSource}>;
  vertical?: "bottom" | "top";
  horizontal?: "left" | "right";
};

type Props = OwnProps;

export const SnackBarBulkExport: React.FC<Props> = (props: Props) => {
  const [context] = useBulkExportAPI();
  const measurement = useHookSubscribe(undefined, context.buildDataSource$);
  const [openSnackBar, setOpenSnackBar] = React.useState(false);
  
  const handleClose = (event: React.SyntheticEvent | React.MouseEvent, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnackBar(false);
  };

  React.useEffect(() => {
    if (measurement && !openSnackBar) {
      setOpenSnackBar(true);
    }
  }, [measurement]);

  const Message = props.messageComponent;

  return (// TODO: Вынести стилизацию сообщения
    <div>
      <Snackbar
        anchorOrigin={{
          vertical: props.vertical || "bottom",
          horizontal: props.horizontal || "left",
        }}
        open={openSnackBar}
        onClose={handleClose}
        message={<Message measurement={measurement} />}
        action={
          <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose}>
            <CloseIcon fontSize="small" />
          </IconButton>
        }
        disableWindowBlurListener
      />
    </div>
  );
};
